import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informes-periciales',
  templateUrl: './informes-periciales.component.html',
  styleUrls: ['./informes-periciales.component.scss']
})
export class InformesPericialesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
